export default {
  'setFormFieldValue.title': 'Acción Establecer Datos de Formulario',

  'setFormFieldValue.form.responseHttpStatusCode': 'Código Respuesta Http',
  'setFormFieldValue.form.sourceParameterPosition': 'Posición Parámetro Respuesta',
  'setFormFieldValue.form.valueDestination': 'Destino Valor',
  'setFormFieldValue.form.sourceForm': 'Formulario Origen',
  'setFormFieldValue.form.sourceField': 'Campo Origen',
  'setFormFieldValue.form.formFieldValueSource': 'Origen Valor Campo',

  'setFormFieldValue.form.valueSource': 'Origen Valor',
  'setFormFieldValue.form.sourceVariable': 'Variable Origen',
  'setFormFieldValue.form.form': 'Formulario',
  'setFormFieldValue.form.field': 'Campo',

  'setFormFieldValue.form.select.FormField': 'Formulario / Campo',
  'setFormFieldValue.form.select.Variable': 'Variable',
  'setFormFieldValue.form.select.Formula': 'Formula',
  'setFormFieldValue.form.select.FixedValue': 'Valor Fijo',
  'setFormFieldValue.form.select.InternalField': 'Campo Interno',
  'setFormFieldValue.form.select.IterationStepData': 'Iteración / Datos',
  'setFormFieldValue.form.select.GeneratedDocument': 'Documento Generado',
};
